import { render, staticRenderFns } from "./full-screen-layout.vue?vue&type=template&id=5742ff38&scoped=true&"
import script from "./full-screen-layout.vue?vue&type=script&lang=js&"
export * from "./full-screen-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742ff38",
  null
  
)

export default component.exports